<template>
    <div>
        <a v-show="showCreeper" v-scroll="handleScroll" href="#top" class="link-to-top">
            <span class="arrow-icon">
                <svg class="icon icon-hsy-icon-arrow-right-short-bold">
                    <use xlink:href="#icon-hsy-icon-arrow-right-short-bold"></use>
                </svg>
            </span>
        </a>
    </div>
</template>
<script>
    export default {
        directives: {
            scroll: {
                inserted: function (el, binding) {
                    let f = function (evt) {
                        if (binding.value(evt, el)) {
                            window.removeEventListener('scroll', f)
                        }
                    }
                    window.addEventListener('scroll', f)
                }
            }
        },
        data: () => {
            return {
                showCreeper: false
            }
        },
        methods: {
            handleScroll: function () {
                if (window.scrollY > 2000) {
                    this.showCreeper = true
                } else {
                    this.showCreeper = false
                }
            }
        }
    }
</script>